// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Without this, padding adds to an element's declared width instead of
   being included in it — that's what was pushing .main-content and its
   children past their container and getting clipped by .image-grid's
   overflow-x: hidden (the "cut off on the right" issue). */
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  /* A wide element (e.g. a comparison table) further down the page can
     stretch the whole document horizontally, exposing this unstyled area
     past the app's dark/light background — the "white bar" on mobile.
     Clamping width + hiding horizontal overflow here stops that. */
  overflow-x: hidden;
  width: 100%;
  background: var(--bg);
}

/* ===== Theme tokens ===== */
:root {
  --bg: #ffffff;
  --surface: #fbfbfa;
  --border: #e4e4e1;
  --text-primary: #14151a;
  --text-secondary: #6b6d73;
  --header-bg: rgba(255, 255, 255, 0.88);
  --skeleton-base: #eceeef;
  --skeleton-shine: #f7f8f8;
}

.dark-mode {
  --bg: #0b0d10;
  --surface: #16181c;
  --border: #262a30;
  --text-primary: #f4f4f2;
  --text-secondary: #8b8f96;
  --header-bg: rgba(15, 17, 20, 0.85);
  --skeleton-base: #1c1f24;
  --skeleton-shine: #23262b;

  background: var(--bg);
  color: var(--text-primary);
}

body {
  margin: 0;
  width: 100%;
  overflow-x: hidden;
  background: var(--bg);
  color: var(--text-primary);
  transition: background 0.2s ease, color 0.2s ease;
}

.dark-mode a {
  color: var(--text-primary);
}

/* Root Layout */
.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--bg);
}

/* ===== Sticky Banner/Header ===== */
.banner {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 14px 24px;
  background: var(--header-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 0.5px solid var(--border);
}

.banner-link {
  flex: 0 0 auto;
  text-decoration: none;
  color: inherit;
}

.banner h1,
.banner-link h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.3px;
  color: var(--text-primary);
}

/* Category nav */
.nav {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: auto;
}

.nav-link {
  font-size: 13px;
  color: var(--text-secondary);
  text-decoration: none;
  padding: 4px 2px;
  border-bottom: 2px solid transparent;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.nav-link:hover {
  color: var(--text-primary);
}

.nav-link.active {
  color: var(--text-primary);
  border-bottom-color: var(--text-primary);
}

@media (max-width: 640px) {
  .nav {
    gap: 12px;
  }
  .banner {
    gap: 12px;
    padding: 12px 16px;
  }
}

@media (max-width: 480px) {
  .nav {
    display: none; /* keep the header from wrapping on very small screens */
  }
}

/* Dark Mode Toggle */
.dark-toggle {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: var(--surface);
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 0.15s ease;
}

.dark-toggle:hover {
  background: var(--border);
}

/* Main Content (scrollable area) */
.main-content {
  flex: 1 1;
  max-width: 1280px;
  margin: 0 auto;
  width: 100%;
  padding: 28px 24px 48px;
}

/* ===== NxN Grid Layout ===== */
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
}

.image-card {
  display: block;
  background: var(--surface);
  border: 0.5px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.image-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  border-color: var(--text-secondary);
}

.dark-mode .image-card:hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
}

.image-card-media {
  aspect-ratio: 16 / 9;
  background: var(--border);
  overflow: hidden;
}

.image-card-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
  cursor: pointer;
}

.image-card-body {
  padding: 14px 16px 16px;
}

.image-card-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--text-primary);
}

.image-card-excerpt {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.end-message {
  text-align: center;
  color: var(--text-secondary);
  font-size: 14px;
  padding: 24px 0;
}

/* ===== Category pills ===== */
.pill {
  display: inline-block;
  font-size: 11px;
  font-weight: 500;
  padding: 3px 9px;
  border-radius: 20px;
  margin-bottom: 10px;
}

.pill-teal   { background: #e1f5ee; color: #085041; }
.pill-pink   { background: #fbeaf0; color: #72243e; }
.pill-amber  { background: #faeeda; color: #633806; }
.pill-purple { background: #f0eafb; color: #4a2472; }
.pill-blue   { background: #e5eefb; color: #0d3a72; }
.pill-green  { background: #eaf6df; color: #2e5211; }

.dark-mode .pill-teal   { background: #1a2e26; color: #5dcaa5; }
.dark-mode .pill-pink   { background: #2e1a24; color: #ed93b1; }
.dark-mode .pill-amber  { background: #2e2a18; color: #fac775; }
.dark-mode .pill-purple { background: #241a2e; color: #c39bed; }
.dark-mode .pill-blue   { background: #182530; color: #7fb0ed; }
.dark-mode .pill-green  { background: #1c2617; color: #a3d97a; }

/* ===== Skeleton loading state ===== */
.skeleton-grid {
  margin-top: 20px;
}

.skeleton-block {
  background: linear-gradient(90deg, var(--skeleton-base) 25%, var(--skeleton-shine) 50%, var(--skeleton-base) 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s ease-in-out infinite;
  border-radius: 6px;
}

.skeleton-media {
  aspect-ratio: 16 / 9;
  border-radius: 0;
}

.skeleton-pill {
  width: 70px;
  height: 18px;
  border-radius: 20px;
  margin-bottom: 10px;
}

.skeleton-line {
  width: 100%;
  height: 14px;
  margin-bottom: 8px;
}

.skeleton-line.short {
  width: 60%;
}

.skeleton-card {
  cursor: default;
}

.skeleton-card:hover {
  transform: none;
  box-shadow: none;
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ===== Article page ===== */
.post-page {
  padding: 16px;
  max-width: 720px;
  margin: 0 auto;
}

.not-found {
  text-align: center;
  padding: 48px 0;
  color: var(--text-secondary);
}

.post-title {
  font-size: 28px;
  font-weight: 500;
  line-height: 1.3;
  color: var(--text-primary);
  margin: 0 0 16px;
}

.post-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 22px;
  font-size: 13px;
  color: var(--text-secondary);
}

.post-author-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  background: var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  flex-shrink: 0;
}

.post-author-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.post-author-name {
  color: var(--text-primary);
  font-weight: 500;
}

.post-meta-dot {
  color: var(--border);
}

.inline-icon {
  vertical-align: -2px;
  margin-right: 2px;
}

.post-actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 0.15s ease;
}

.icon-button:hover {
  background: var(--surface);
}

.post-img {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  object-position: center top;
  border-radius: 10px;
  margin-bottom: 22px;
  display: block;
}

/* Images embedded inside the article body itself (from the rich-text
   \`description\` field) aren't covered by .post-img — constrain those too
   so an inline portrait/square image can't blow out the layout. */
.post-body img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 8px 0 16px;
}

.post-page img {
  max-width: 100%;
  display: block;
}

.post-body {
  font-size: 16px;
  line-height: 1.7;
  color: var(--text-primary);
}

.post-body h3 {
  font-size: 19px;
  font-weight: 500;
  margin: 28px 0 10px;
}

.post-body p {
  margin: 0 0 14px;
  opacity: 0.88;
}

.post-body ul {
  margin: 0 0 14px;
  padding-left: 20px;
}

.post-body li {
  margin-bottom: 8px;
  line-height: 1.6;
}

.post-page table,
.post-body table {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-collapse: collapse;
  margin: 8px 0 20px;
  font-size: 14px;
}

.post-page th,
.post-page td,
.post-body th,
.post-body td {
  border: 1px solid var(--border);
  padding: 8px 10px;
  text-align: left;
}

.post-page th,
.post-body th {
  background: var(--surface);
  color: var(--text-primary);
}

.hashtags {
  margin: 24px 0 0;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.hashtag {
  font-size: 13px;
  color: var(--text-secondary);
  background: var(--surface);
  border: 0.5px solid var(--border);
  padding: 4px 10px;
  border-radius: 20px;
}

/* ===== Related articles ===== */
.related-section {
  margin-top: 36px;
  padding-top: 20px;
  border-top: 0.5px solid var(--border);
}

.related-heading {
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 14px;
}

.related-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}

.related-card {
  display: block;
  background: var(--surface);
  border: 0.5px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  text-decoration: none;
  transition: transform 0.15s ease;
}

.related-card:hover {
  transform: translateY(-3px);
}

.related-card img {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  object-position: center top;
  display: block;
}

.related-card p {
  margin: 0;
  padding: 10px 12px 12px;
  font-size: 13px;
  line-height: 1.4;
  color: var(--text-primary);
}

/* ===== Footer ===== */
.footer {
  text-align: center;
  padding: 24px;
  border-top: 0.5px solid var(--border);
  color: var(--text-secondary);
  font-size: 13px;
}

.footer-links a {
  margin: 0 4px;
  text-decoration: none;
  color: var(--text-secondary);
}

.footer-links a:hover {
  color: var(--text-primary);
}

.footer-divider {
  margin: 0 8px;
  color: var(--border);
}

.footer p {
  margin: 10px 0 0;
}

/* =========================================================================
   Legacy modal styles below.
   None of the current components (App, ImageList, ImageCard, PostPage,
   Footer) reference .modal / .modal-overlay / .close-btn anymore — PostPage
   is a full route now, not a modal. Leaving these in place in case another
   component still uses them; safe to delete if a project-wide search for
   "modal" and "close-btn" turns up nothing else.
   ========================================================================= */

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0,0,0,0.7);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  background: white;
  width: 85%;
  height: 95%;
  border-radius: 10px;
  overflow-y: auto;
  position: relative;
}

.modal-header {
  position: sticky;
  top: 0;
  background: inherit;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  margin: 0;
  z-index: 20;
  border-bottom: 1px solid #ccc;
}

.modal-title {
  font-size: 20px;
  margin: 0;
}

.modal-content {
  margin: 20px;
}

.modal-content img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 12px auto;
}

.dark-mode .modal {
  background: #1e1e1e !important;
  color: #e0e0e0 !important;
}

.dark-mode .modal-img {
  border: 2px solid #333;
}

.dark-mode .modal-actions svg {
  color: #e0e0e0;
}
.dark-mode .modal-actions svg:hover {
  color: #66b2ff;
}

.dark-mode .close-btn {
  background: #ff4d4d;
  color: white;
}
.dark-mode .close-btn:hover {
  background: #cc0000;
}

.dark-mode .modal-overlay {
  background-color: rgba(0,0,0,0.85) !important;
}

.modal-dark {
  background: #1e1e1e;
  color: #e0e0e0;
}

.modal-overlay-dark {
  background-color: rgba(0,0,0,0.85);
}

.modal-dark .modal-actions svg {
  color: #e0e0e0;
}
.modal-dark .modal-actions svg:hover {
  color: #66b2ff;
}

.modal-img {
  max-width: 100%;
  max-height: 70vh;
  height: auto;
  width: auto;
  display: block;
  margin: 0 auto;
  padding-top: 10px;
  border-radius: 8px;
  object-fit: contain;
}

.modal-actions {
  display: flex;
  gap: 30px;
  margin: 20px 0;
  font-size: 30px;
  justify-content: center;
}
.modal-actions svg {
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}
.modal-actions svg:hover {
  transform: scale(1.2);
  color: #007bff;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  color: #888;
  border: none;
  font-size: 30px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.close-btn:hover {
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;2DAG2D;AAC3D;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB;;;mEAGiE;EACjE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,sCAAsC;EACtC,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,mCAAmC;EACnC,wBAAwB;EACxB,yBAAyB;;EAEzB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa,EAAE,wDAAwD;EACzE;AACF;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;;AAEpD,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;;AAE/D,uCAAuC;AACvC;EACE,gBAAgB;AAClB;;AAEA;EACE,iHAAiH;EACjH,0BAA0B;EAC1B,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;kEAEkE;AAClE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;EAIE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;EAC1B,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;8EAO8E;;AAE9E,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* Without this, padding adds to an element's declared width instead of\n   being included in it — that's what was pushing .main-content and its\n   children past their container and getting clipped by .image-grid's\n   overflow-x: hidden (the \"cut off on the right\" issue). */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  /* A wide element (e.g. a comparison table) further down the page can\n     stretch the whole document horizontally, exposing this unstyled area\n     past the app's dark/light background — the \"white bar\" on mobile.\n     Clamping width + hiding horizontal overflow here stops that. */\n  overflow-x: hidden;\n  width: 100%;\n  background: var(--bg);\n}\n\n/* ===== Theme tokens ===== */\n:root {\n  --bg: #ffffff;\n  --surface: #fbfbfa;\n  --border: #e4e4e1;\n  --text-primary: #14151a;\n  --text-secondary: #6b6d73;\n  --header-bg: rgba(255, 255, 255, 0.88);\n  --skeleton-base: #eceeef;\n  --skeleton-shine: #f7f8f8;\n}\n\n.dark-mode {\n  --bg: #0b0d10;\n  --surface: #16181c;\n  --border: #262a30;\n  --text-primary: #f4f4f2;\n  --text-secondary: #8b8f96;\n  --header-bg: rgba(15, 17, 20, 0.85);\n  --skeleton-base: #1c1f24;\n  --skeleton-shine: #23262b;\n\n  background: var(--bg);\n  color: var(--text-primary);\n}\n\nbody {\n  margin: 0;\n  width: 100%;\n  overflow-x: hidden;\n  background: var(--bg);\n  color: var(--text-primary);\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.dark-mode a {\n  color: var(--text-primary);\n}\n\n/* Root Layout */\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: var(--bg);\n}\n\n/* ===== Sticky Banner/Header ===== */\n.banner {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 14px 24px;\n  background: var(--header-bg);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-bottom: 0.5px solid var(--border);\n}\n\n.banner-link {\n  flex: 0 0 auto;\n  text-decoration: none;\n  color: inherit;\n}\n\n.banner h1,\n.banner-link h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: -0.3px;\n  color: var(--text-primary);\n}\n\n/* Category nav */\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-right: auto;\n}\n\n.nav-link {\n  font-size: 13px;\n  color: var(--text-secondary);\n  text-decoration: none;\n  padding: 4px 2px;\n  border-bottom: 2px solid transparent;\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.nav-link:hover {\n  color: var(--text-primary);\n}\n\n.nav-link.active {\n  color: var(--text-primary);\n  border-bottom-color: var(--text-primary);\n}\n\n@media (max-width: 640px) {\n  .nav {\n    gap: 12px;\n  }\n  .banner {\n    gap: 12px;\n    padding: 12px 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .nav {\n    display: none; /* keep the header from wrapping on very small screens */\n  }\n}\n\n/* Dark Mode Toggle */\n.dark-toggle {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 50%;\n  background: var(--surface);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.dark-toggle:hover {\n  background: var(--border);\n}\n\n/* Main Content (scrollable area) */\n.main-content {\n  flex: 1;\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 28px 24px 48px;\n}\n\n/* ===== NxN Grid Layout ===== */\n.image-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n\n.image-card {\n  display: block;\n  background: var(--surface);\n  border: 0.5px solid var(--border);\n  border-radius: 12px;\n  overflow: hidden;\n  text-decoration: none;\n  color: inherit;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n}\n\n.image-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);\n  border-color: var(--text-secondary);\n}\n\n.dark-mode .image-card:hover {\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);\n}\n\n.image-card-media {\n  aspect-ratio: 16 / 9;\n  background: var(--border);\n  overflow: hidden;\n}\n\n.image-card-media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  display: block;\n  cursor: pointer;\n}\n\n.image-card-body {\n  padding: 14px 16px 16px;\n}\n\n.image-card-title {\n  margin: 0 0 8px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: var(--text-primary);\n}\n\n.image-card-excerpt {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.end-message {\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 14px;\n  padding: 24px 0;\n}\n\n/* ===== Category pills ===== */\n.pill {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 500;\n  padding: 3px 9px;\n  border-radius: 20px;\n  margin-bottom: 10px;\n}\n\n.pill-teal   { background: #e1f5ee; color: #085041; }\n.pill-pink   { background: #fbeaf0; color: #72243e; }\n.pill-amber  { background: #faeeda; color: #633806; }\n.pill-purple { background: #f0eafb; color: #4a2472; }\n.pill-blue   { background: #e5eefb; color: #0d3a72; }\n.pill-green  { background: #eaf6df; color: #2e5211; }\n\n.dark-mode .pill-teal   { background: #1a2e26; color: #5dcaa5; }\n.dark-mode .pill-pink   { background: #2e1a24; color: #ed93b1; }\n.dark-mode .pill-amber  { background: #2e2a18; color: #fac775; }\n.dark-mode .pill-purple { background: #241a2e; color: #c39bed; }\n.dark-mode .pill-blue   { background: #182530; color: #7fb0ed; }\n.dark-mode .pill-green  { background: #1c2617; color: #a3d97a; }\n\n/* ===== Skeleton loading state ===== */\n.skeleton-grid {\n  margin-top: 20px;\n}\n\n.skeleton-block {\n  background: linear-gradient(90deg, var(--skeleton-base) 25%, var(--skeleton-shine) 50%, var(--skeleton-base) 75%);\n  background-size: 200% 100%;\n  animation: skeleton-shimmer 1.4s ease-in-out infinite;\n  border-radius: 6px;\n}\n\n.skeleton-media {\n  aspect-ratio: 16 / 9;\n  border-radius: 0;\n}\n\n.skeleton-pill {\n  width: 70px;\n  height: 18px;\n  border-radius: 20px;\n  margin-bottom: 10px;\n}\n\n.skeleton-line {\n  width: 100%;\n  height: 14px;\n  margin-bottom: 8px;\n}\n\n.skeleton-line.short {\n  width: 60%;\n}\n\n.skeleton-card {\n  cursor: default;\n}\n\n.skeleton-card:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n@keyframes skeleton-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ===== Article page ===== */\n.post-page {\n  padding: 16px;\n  max-width: 720px;\n  margin: 0 auto;\n}\n\n.not-found {\n  text-align: center;\n  padding: 48px 0;\n  color: var(--text-secondary);\n}\n\n.post-title {\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: var(--text-primary);\n  margin: 0 0 16px;\n}\n\n.post-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 22px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.post-author-avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n.post-author-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.post-author-name {\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n.post-meta-dot {\n  color: var(--border);\n}\n\n.inline-icon {\n  vertical-align: -2px;\n  margin-right: 2px;\n}\n\n.post-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n}\n\n.icon-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.icon-button:hover {\n  background: var(--surface);\n}\n\n.post-img {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n  object-position: center top;\n  border-radius: 10px;\n  margin-bottom: 22px;\n  display: block;\n}\n\n/* Images embedded inside the article body itself (from the rich-text\n   `description` field) aren't covered by .post-img — constrain those too\n   so an inline portrait/square image can't blow out the layout. */\n.post-body img {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin: 8px 0 16px;\n}\n\n.post-page img {\n  max-width: 100%;\n  display: block;\n}\n\n.post-body {\n  font-size: 16px;\n  line-height: 1.7;\n  color: var(--text-primary);\n}\n\n.post-body h3 {\n  font-size: 19px;\n  font-weight: 500;\n  margin: 28px 0 10px;\n}\n\n.post-body p {\n  margin: 0 0 14px;\n  opacity: 0.88;\n}\n\n.post-body ul {\n  margin: 0 0 14px;\n  padding-left: 20px;\n}\n\n.post-body li {\n  margin-bottom: 8px;\n  line-height: 1.6;\n}\n\n.post-page table,\n.post-body table {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  border-collapse: collapse;\n  margin: 8px 0 20px;\n  font-size: 14px;\n}\n\n.post-page th,\n.post-page td,\n.post-body th,\n.post-body td {\n  border: 1px solid var(--border);\n  padding: 8px 10px;\n  text-align: left;\n}\n\n.post-page th,\n.post-body th {\n  background: var(--surface);\n  color: var(--text-primary);\n}\n\n.hashtags {\n  margin: 24px 0 0;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.hashtag {\n  font-size: 13px;\n  color: var(--text-secondary);\n  background: var(--surface);\n  border: 0.5px solid var(--border);\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n/* ===== Related articles ===== */\n.related-section {\n  margin-top: 36px;\n  padding-top: 20px;\n  border-top: 0.5px solid var(--border);\n}\n\n.related-heading {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-bottom: 14px;\n}\n\n.related-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 14px;\n}\n\n.related-card {\n  display: block;\n  background: var(--surface);\n  border: 0.5px solid var(--border);\n  border-radius: 10px;\n  overflow: hidden;\n  text-decoration: none;\n  transition: transform 0.15s ease;\n}\n\n.related-card:hover {\n  transform: translateY(-3px);\n}\n\n.related-card img {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n  object-position: center top;\n  display: block;\n}\n\n.related-card p {\n  margin: 0;\n  padding: 10px 12px 12px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--text-primary);\n}\n\n/* ===== Footer ===== */\n.footer {\n  text-align: center;\n  padding: 24px;\n  border-top: 0.5px solid var(--border);\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n\n.footer-links a {\n  margin: 0 4px;\n  text-decoration: none;\n  color: var(--text-secondary);\n}\n\n.footer-links a:hover {\n  color: var(--text-primary);\n}\n\n.footer-divider {\n  margin: 0 8px;\n  color: var(--border);\n}\n\n.footer p {\n  margin: 10px 0 0;\n}\n\n/* =========================================================================\n   Legacy modal styles below.\n   None of the current components (App, ImageList, ImageCard, PostPage,\n   Footer) reference .modal / .modal-overlay / .close-btn anymore — PostPage\n   is a full route now, not a modal. Leaving these in place in case another\n   component still uses them; safe to delete if a project-wide search for\n   \"modal\" and \"close-btn\" turns up nothing else.\n   ========================================================================= */\n\n/* Modal Overlay */\n.modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background-color: rgba(0,0,0,0.7);\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal {\n  background: white;\n  width: 85%;\n  height: 95%;\n  border-radius: 10px;\n  overflow-y: auto;\n  position: relative;\n}\n\n.modal-header {\n  position: sticky;\n  top: 0;\n  background: inherit;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  margin: 0;\n  z-index: 20;\n  border-bottom: 1px solid #ccc;\n}\n\n.modal-title {\n  font-size: 20px;\n  margin: 0;\n}\n\n.modal-content {\n  margin: 20px;\n}\n\n.modal-content img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 12px auto;\n}\n\n.dark-mode .modal {\n  background: #1e1e1e !important;\n  color: #e0e0e0 !important;\n}\n\n.dark-mode .modal-img {\n  border: 2px solid #333;\n}\n\n.dark-mode .modal-actions svg {\n  color: #e0e0e0;\n}\n.dark-mode .modal-actions svg:hover {\n  color: #66b2ff;\n}\n\n.dark-mode .close-btn {\n  background: #ff4d4d;\n  color: white;\n}\n.dark-mode .close-btn:hover {\n  background: #cc0000;\n}\n\n.dark-mode .modal-overlay {\n  background-color: rgba(0,0,0,0.85) !important;\n}\n\n.modal-dark {\n  background: #1e1e1e;\n  color: #e0e0e0;\n}\n\n.modal-overlay-dark {\n  background-color: rgba(0,0,0,0.85);\n}\n\n.modal-dark .modal-actions svg {\n  color: #e0e0e0;\n}\n.modal-dark .modal-actions svg:hover {\n  color: #66b2ff;\n}\n\n.modal-img {\n  max-width: 100%;\n  max-height: 70vh;\n  height: auto;\n  width: auto;\n  display: block;\n  margin: 0 auto;\n  padding-top: 10px;\n  border-radius: 8px;\n  object-fit: contain;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 30px;\n  margin: 20px 0;\n  font-size: 30px;\n  justify-content: center;\n}\n.modal-actions svg {\n  cursor: pointer;\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n.modal-actions svg:hover {\n  transform: scale(1.2);\n  color: #007bff;\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: transparent;\n  color: #888;\n  border: none;\n  font-size: 30px;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.close-btn:hover {\n  color: #333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
